import { Alert } from "@circleco/compass/components/Alert";

export interface ImageErrorProps {
  error?: string;
}

export const ImageError = ({ error }: ImageErrorProps) => {
  if (!error) return null;
  return (
    <div className="mb-4">
      <Alert variant="destructive" description={error} />
    </div>
  );
};
